import { useCallback } from 'react';

import {
	useObjectSidebarActions,
	useIsObjectSidebarShown,
	usePanel,
	PanelName,
} from '@confluence/object-sidebar-api';

import { messages } from '../../messages';

import { LoomScriptPanelHeaderIcon } from './LoomScriptPanelHeaderIcon';
import { LoomScriptPanelBody } from './LoomScriptPanelBody';
import { LoomScriptPanelFooter } from './LoomScriptPanelFooter';

export const useShowLoomScriptPanel = () => {
	const { showObjectSidebar } = useObjectSidebarActions();
	const isObjectSidebarShown = useIsObjectSidebarShown();
	const panel = usePanel();

	const showLoomScriptPanel = useCallback(
		(onRecordVideoClick?: () => void) => {
			showObjectSidebar(
				{
					id: PanelName.LoomScriptPanel,
					headerComponentElements: {
						HeaderIcon: LoomScriptPanelHeaderIcon,
						headerLabel: messages.loomScriptTitle,
					},
					BodyComponent: () => LoomScriptPanelBody({ onRecordVideoClick }),
					FooterComponent: LoomScriptPanelFooter,
				},
				'push',
			);
		},
		[showObjectSidebar],
	);

	return {
		isLoomScriptPanelShown: isObjectSidebarShown && panel?.id === PanelName.LoomScriptPanel,
		showLoomScriptPanel,
	};
};
